const state = {
  // 脑电：status 见 onMqttMessageUtils 映射；voltage 电压；battery 电量百分比
  eeg: {
    status: '',
    voltage: 0,
    battery: 0,
    btName: '',
    btMac: ''
  },
  // 眼动仪：'1' 已连接，'0' 未连接
  eyeTracker: {
    status: '0'
  }
}

const getters = {
  eeg: (state) => state.eeg,
  eyeTracker: (state) => state.eyeTracker,
  eegStatus: (state) => state.eeg.status,
  eegBattery: (state) => state.eeg.battery,
  eegBtName: (state) => state.eeg.btName || '',
  eegBtMac: (state) => state.eeg.btMac || '',
  eyeTrackerStatus: (state) => state.eyeTracker.status
}

const mutations = {
  SET_EEG(state, payload) {
    state.eeg = { ...state.eeg, ...payload }
  },
  SET_EYE_TRACKER(state, payload) {
    state.eyeTracker = { ...state.eyeTracker, ...payload }
  },
  RESET_DEVICE(state) {
    state.eeg = { status: '', voltage: 0, battery: 0, btName: '', btMac: '' }
    state.eyeTracker = { status: '0' }
  }
}

const actions = {
  updateEeg({ commit }, payload) {
    commit('SET_EEG', payload)
  },
  updateEyeTracker({ commit }, payload) {
    commit('SET_EYE_TRACKER', payload)
  },
  resetDevice({ commit }) {
    commit('RESET_DEVICE')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
